<template>
  <div class="grid-x align-center article" v-if="post">
    <div class="cell small-11 medium-8 large-6">
      <div class="top" :class="{ '-right': !$slots.default }">
        <slot></slot>
        <time v-if="!hideTime" class="date" :datetime="post.date">{{
          formattedDate
        }}</time>
      </div>
      <h1 class="title -no-tt">{{ post.title }}</h1>
      <p>
        <button @click="print" class="text -t3 -print">
          Print this article
        </button>
      </p>
      <p class="return-link">
        <router-link class="text -t3" :to="returnTo">{{
          returnLabel
        }}</router-link>
      </p>
      <v-content class="content" :blocks="post.content" />
      <p class="return-link">
        <router-link class="text -t3" :to="returnTo">{{
          returnLabel
        }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VContent from "@/components/content/Content.vue";

export default {
  props: {
    post: Object,
    returnLabel: String,
    returnTo: Object,
    hideTime: Boolean,
  },
  components: {
    VContent,
  },
  data() {
    return {};
  },
  computed: {
    formattedDate() {
      return moment.utc(this.post.date).format("Do MMMM YYYY");
    },
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.article {
  margin: vw-relative(64 0);
}
.top {
  display: flex;
  justify-content: space-between;
  &.-right {
    justify-content: flex-end;
  }
}
.date {
  display: block;
  font: 600 16px/1 CenturyGothic;
  text-transform: uppercase;
  margin-bottom: 0.5em;
  color: #6b2377;
}
.return-link {
  margin-bottom: vw-relative(24);
  a {
    color: #95C11F;
  }
}
.title {
  margin: 0.2em 0;
}
.text {
  margin-bottom: 0.6em;
}
.content {
  margin-bottom: vw-relative(40);
}
</style>
